import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';

class BrandSignupIndexRoute extends Route {
  @service router;
  @service session;

  /** @inheritDoc */
  redirect() {
    if (this.session.currentUser) {
      this.router.replaceWith(EMBER_ROUTE_NAMES.START);
    }
  }

  setupController(controller) {
    super.setupController(...arguments);

    const directAssignmentDraftUUID = sessionStorage.getItem('directAssignmentDraftId');

    if (directAssignmentDraftUUID) {
      controller.loadDirectAssignmentFreelancer.perform(directAssignmentDraftUUID);
    }
  }

  resetController(controller, isExiting) {
    super.resetController(...arguments);

    if (isExiting) {
      controller.loadDirectAssignmentFreelancer.cancelAll({ resetState: true });
      controller.onGoogleSSO.cancelAll({ resetState: true });
      controller.createUser.cancelAll({ resetState: true });
    }
  }

  activate(transition) {
    super.activate(...arguments);
    trackPageViewFromTransition(this, transition, '/brand/signup/');
  }
}

export default BrandSignupIndexRoute;
